import { render } from "./ProductPriceChangeModal.vue?vue&type=template&id=742c9be0"
import script from "./ProductPriceChangeModal.vue?vue&type=script&lang=js"
export * from "./ProductPriceChangeModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__